var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestsS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38859 15.374C2.40053 15.759 2.41251 16.1451 2.41251 16.5312C5.21972 16.5312 8.02694 16.5312 10.8413 16.5288C10.1042 15.7541 9.65173 14.706 9.65173 13.5522C9.65173 11.4307 11.1813 9.66653 13.1978 9.30232C12.9342 9.26076 12.6603 9.23872 12.3773 9.23743H10.3526C12.3895 8.51782 13.4994 6.99321 13.2677 5.18807C13.0359 3.41953 11.6333 2.06568 9.90136 1.94371C8.16941 1.82174 6.58383 2.93165 6.12035 4.61482C5.83982 5.63936 5.98618 6.61511 6.53504 7.50548C7.0839 8.40804 7.91328 8.93251 8.91342 9.21304C8.47308 9.23336 8.04027 9.23487 7.60872 9.23637C7.26329 9.23758 6.91866 9.23878 6.57163 9.24963C4.51037 9.31061 2.69304 10.823 2.43691 12.8721C2.33642 13.6928 2.36242 14.5307 2.38859 15.374Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3814 18.0653C16.7666 18.0653 18.7002 16.1317 18.7002 13.7465C18.7002 11.3613 16.7666 9.42773 14.3814 9.42773C11.9962 9.42773 10.0626 11.3613 10.0626 13.7465C10.0626 16.1317 11.9962 18.0653 14.3814 18.0653ZM17.1944 12.3407C17.367 12.1619 17.362 11.877 17.1832 11.7044C17.0044 11.5318 16.7196 11.5368 16.5469 11.7156L13.5409 14.8289L12.2053 13.5378C12.0266 13.3651 11.7417 13.3699 11.569 13.5486C11.3962 13.7273 11.4011 14.0122 11.5797 14.1849L13.2391 15.789C13.325 15.872 13.4403 15.9174 13.5597 15.9154C13.679 15.9133 13.7927 15.8639 13.8756 15.778L17.1944 12.3407Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestsS);
export default __webpack_public_path__ + "static/media/requests_s.551c90200eab21940a56d07f389c9b77.svg";
export { ForwardRef as ReactComponent };